export function PresentationPage() {
  return (
    <main className="presentation-shell">
      <iframe
        className="presentation-frame"
        src="/deck/index.html"
        title="Apresentação de investimento ASTER"
        allow="fullscreen"
      />
    </main>
  );
}
